import { ThemeEvents } from '@theme/events';
import { formatMoney } from '@theme/money-formatting';

/**
 * Keeps the product-page free-delivery announcement message in sync with the
 * currently selected variant's price, without a page reload.
 */

const MESSAGE_SELECTOR = '[data-archive-delivery-message]';
const FREE_DELIVERY_MESSAGE = 'Great news! This bottle unlocks FREE delivery to most of Australia.';

/**
 * @param {HTMLElement} message
 * @returns {string}
 */
function getMoneyFormat(message) {
  const template = message.parentElement?.querySelector('[data-archive-delivery-money-format]');
  return (template instanceof HTMLTemplateElement && template.content.textContent?.trim()) || '${{amount}}';
}

/**
 * @param {HTMLElement} message
 * @param {number} remainingCents
 */
function updateMessage(message, remainingCents) {
  if (remainingCents <= 0) {
    message.textContent = FREE_DELIVERY_MESSAGE;
    return;
  }

  const currency = message.dataset.archiveDeliveryCurrency || 'AUD';
  const amount = formatMoney(remainingCents, getMoneyFormat(message), currency);
  message.textContent = `Add ${amount} more to unlock FREE delivery to most of Australia.`;
}

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const message = document.querySelector(MESSAGE_SELECTOR);
  if (!(message instanceof HTMLElement)) return;

  // Only react to the variant picker for the product currently displayed on this template
  // (ignores swatch/variant changes on unrelated product cards, e.g. recommendations).
  const target = event.target;
  if (!(target instanceof HTMLElement) || target.getAttribute('data-template-product-match') !== 'true') return;

  const price = event.detail?.resource?.price;
  if (typeof price !== 'number') return;

  const threshold = parseInt(message.dataset.archiveDeliveryThresholdCents ?? '', 10);
  if (Number.isNaN(threshold)) return;

  updateMessage(message, threshold - price);
});
